import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { checkSiniestro } from '../api/informesApi'
export const useCheckSiniestro = (trigger, periodoData, contrato) => {
  const [hasData, setHasData] = useState(false)
  const [validatedTrigger, setValidatedTrigger] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato || !periodoData?.fechaDesde || !periodoData?.fechaHasta) {
      setHasData(false)
      setValidatedTrigger(null)
      setIsLoading(false)
      setError(null)
      return
    }

    const controller = new AbortController()

    const fetchData = async () => {
      setHasData(false)
      setValidatedTrigger(null)
      setIsLoading(true)
      setError(null)
      try {
        const response = await checkSiniestro(contrato, periodoData.fechaDesde, periodoData.fechaHasta, {
          signal: controller.signal,
        })
        const canGenerateReport = response.data.generarInforme === true
        setHasData(canGenerateReport)
        setValidatedTrigger(canGenerateReport ? trigger : null)
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setHasData(false)
        setValidatedTrigger(null)
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, periodoData?.fechaDesde, periodoData?.fechaHasta, contrato])

  return { hasData, validatedTrigger, isLoading, error }
}
